export enum AuthProviderType {
  telegram = 'telegram',
  discord = 'discord',
  otp = 'otp'
}
